import { theme } from '@frontend/theme';
import { useCalendarGridStore } from '../../store/calendar-grid.store';
import { getHourLineBackgroundStyle } from '../styles';

interface Props {
  gridColumn: string;
}

export const GroupHourLines = ({ gridColumn }: Props) => {
  const timeIndicatorLines = useCalendarGridStore((s) => s.timeIndicatorLines);
  if (timeIndicatorLines === 'none') return null;

  return (
    <div
      data-group-hour-lines
      css={[
        {
          boxShadow: theme.shadows.light,
          gridColumn,
          gridRow: '2 / -1',
        },
        getHourLineBackgroundStyle(timeIndicatorLines),
      ]}
    />
  );
};
